import { toast } from "sonner";
import { Empty, PortalHeading } from "./PortalLayout";
import { useFetch } from "@/hooks/useFetch";
import { api, money } from "@/lib/api";

export default function Approvals() {
  const { data, reload } = useFetch("/portal/approvals");
  const decide = async (id, decision) => {
    await api.post(`/portal/approvals/${id}/decide`, { decision });
    toast.success(decision === "approve" ? "Extra work approved" : "Extra work declined");
    reload();
  };
  return (
    <div data-testid="portal-approvals">
      <PortalHeading title="Approval Centre" sub="Extra work found during assessment. Nothing starts without your yes." />
      {data && !data.approvals.length && <Empty testId="approvals-empty">Nothing waiting for your approval.</Empty>}
      <div className="space-y-3">
        {data?.approvals.map((a) => (
          <div key={a.id} className="rounded-2xl bg-white p-5 flex flex-wrap items-center gap-4" data-testid={`approval-item-${a.id}`}>
            <div className="flex-1 min-w-[200px]"><p className="text-xs font-bold tracking-widest text-[#F86900]">{a.job_reference}</p><p className="font-semibold">{a.title}</p>{a.description && <p className="text-sm text-[#56585E]">{a.description}</p>}</div>
            <p className="font-display text-xl font-extrabold">+{money(a.amount)}</p>
            <button onClick={() => decide(a.id, "approve")} data-testid={`approval-item-approve-${a.id}`} className="rounded-full bg-[#020165] text-white px-5 py-2 text-sm font-semibold">Approve</button>
            <button onClick={() => decide(a.id, "reject")} data-testid={`approval-item-reject-${a.id}`} className="rounded-full border px-5 py-2 text-sm font-semibold">Reject</button>
          </div>
        ))}
      </div>
    </div>
  );
}
